import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import $icz4I$react, { useState as $icz4I$useState, useImperativeHandle as $icz4I$useImperativeHandle, Fragment as $icz4I$Fragment } from "react";
import $icz4I$reactdom from "react-dom";
import { VisuallyHidden as $icz4I$VisuallyHidden } from "@react-aria/visually-hidden";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $9694eec57086f168$exports = {};
$parcel$export($9694eec57086f168$exports, "announce", function () {
  return $9694eec57086f168$export$a9b970dcc4ae71a9;
});
$parcel$export($9694eec57086f168$exports, "clearAnnouncer", function () {
  return $9694eec57086f168$export$d10ae4f68404609a;
});
$parcel$export($9694eec57086f168$exports, "destroyAnnouncer", function () {
  return $9694eec57086f168$export$d8686216b8b81b2f;
});
/* Inspired by https://github.com/AlmeroSteyn/react-aria-live */

var $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY = 7000;
var $9694eec57086f168$var$liveRegionAnnouncer = /*#__PURE__*/$icz4I$react.createRef();
var $9694eec57086f168$var$node = null;
var $9694eec57086f168$var$messageId = 0;

function $9694eec57086f168$export$a9b970dcc4ae71a9(message) {
  var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY;
  $9694eec57086f168$var$ensureInstance(function (announcer) {
    return announcer.announce(message, assertiveness, timeout);
  });
}

function $9694eec57086f168$export$d10ae4f68404609a(assertiveness) {
  $9694eec57086f168$var$ensureInstance(function (announcer) {
    return announcer.clear(assertiveness);
  });
}

function $9694eec57086f168$export$d8686216b8b81b2f() {
  if ($9694eec57086f168$var$liveRegionAnnouncer.current) {
    $icz4I$reactdom.unmountComponentAtNode($9694eec57086f168$var$node);
    document.body.removeChild($9694eec57086f168$var$node);
    $9694eec57086f168$var$node = null;
  }
}
/**
 * Ensures we only have one instance of the announcer so that we don't have elements competing.
 */


function $9694eec57086f168$var$ensureInstance(callback) {
  if (!$9694eec57086f168$var$liveRegionAnnouncer.current) {
    $9694eec57086f168$var$node = document.createElement('div');
    $9694eec57086f168$var$node.dataset.liveAnnouncer = 'true';
    document.body.prepend($9694eec57086f168$var$node);
    $icz4I$reactdom.render( /*#__PURE__*/$icz4I$react.createElement($9694eec57086f168$var$LiveRegionAnnouncer, {
      ref: $9694eec57086f168$var$liveRegionAnnouncer
    }), $9694eec57086f168$var$node, function () {
      return callback($9694eec57086f168$var$liveRegionAnnouncer.current);
    });
  } else callback($9694eec57086f168$var$liveRegionAnnouncer.current);
}

var $9694eec57086f168$var$LiveRegionAnnouncer = /*#__PURE__*/$icz4I$react.forwardRef(function (_, ref) {
  var _$icz4I$useState = $icz4I$useState([]),
      _$icz4I$useState2 = _slicedToArray(_$icz4I$useState, 2),
      assertiveMessages = _$icz4I$useState2[0],
      setAssertiveMessages = _$icz4I$useState2[1];

  var _$icz4I$useState3 = $icz4I$useState([]),
      _$icz4I$useState4 = _slicedToArray(_$icz4I$useState3, 2),
      politeMessages = _$icz4I$useState4[0],
      setPoliteMessages = _$icz4I$useState4[1];

  var clear = function clear(assertiveness) {
    if (!assertiveness || assertiveness === 'assertive') setAssertiveMessages([]);
    if (!assertiveness || assertiveness === 'polite') setPoliteMessages([]);
  };

  var $9694eec57086f168$export$a9b970dcc4ae71a9 = function $9694eec57086f168$export$a9b970dcc4ae71a9(message1) {
    var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $9694eec57086f168$var$LIVEREGION_TIMEOUT_DELAY;
    var id = $9694eec57086f168$var$messageId++;
    if (assertiveness === 'assertive') setAssertiveMessages(function (messages) {
      return [].concat(_toConsumableArray(messages), [{
        id: id,
        text: message1
      }]);
    });else setPoliteMessages(function (messages) {
      return [].concat(_toConsumableArray(messages), [{
        id: id,
        text: message1
      }]);
    });
    if (message1 !== '') setTimeout(function () {
      if (assertiveness === 'assertive') setAssertiveMessages(function (messages) {
        return messages.filter(function (message) {
          return message.id !== id;
        });
      });else setPoliteMessages(function (messages) {
        return messages.filter(function (message) {
          return message.id !== id;
        });
      });
    }, timeout);
  };

  $icz4I$useImperativeHandle(ref, function () {
    return {
      announce: $9694eec57086f168$export$a9b970dcc4ae71a9,
      clear: clear
    };
  });
  return /*#__PURE__*/$icz4I$react.createElement($icz4I$Fragment, null, /*#__PURE__*/$icz4I$react.createElement($9694eec57086f168$var$MessageBlock, {
    "aria-live": "assertive"
  }, assertiveMessages.map(function (message) {
    return /*#__PURE__*/$icz4I$react.createElement("div", {
      key: message.id
    }, message.text);
  })), /*#__PURE__*/$icz4I$react.createElement($9694eec57086f168$var$MessageBlock, {
    "aria-live": "polite"
  }, politeMessages.map(function (message) {
    return /*#__PURE__*/$icz4I$react.createElement("div", {
      key: message.id
    }, message.text);
  })));
});

function $9694eec57086f168$var$MessageBlock(_ref) {
  var children = _ref.children,
      ariaLive = _ref['aria-live'];
  return /*#__PURE__*/$icz4I$react.createElement($icz4I$VisuallyHidden, {
    role: "log",
    "aria-live": ariaLive,
    "aria-relevant": "additions"
  }, children);
}

export { $9694eec57086f168$export$a9b970dcc4ae71a9 as announce, $9694eec57086f168$export$d10ae4f68404609a as clearAnnouncer, $9694eec57086f168$export$d8686216b8b81b2f as destroyAnnouncer };